import { Box } from '@chakra-ui/react';
import { useScroll, useSpring } from 'framer-motion';
import { rem } from 'polished';
import { MotionBox } from '../MotionBox';

export const ScrollProgress = ({ background }: { background: string | string[] }) => {
  const { scrollYProgress } = useScroll();
  const progress = useSpring(scrollYProgress, {
    stiffness: 100,
    damping: 30,
    restDelta: 0.001,
  });

  return (
    <Box
      pos="fixed"
      top={0}
      left={0}
      right={0}
      h={rem(2)}
      zIndex="in-front"
      bg="rgba(255, 255, 255, 0.2)"
    >
      <MotionBox
        h="100%"
        transformOrigin="left"
        bg={
          Array.isArray(background) ? `linear-gradient(90deg, ${background.join(',')})` : background
        }
        style={{ scaleX: progress }}
        roundedRight="radius.4"
      />
    </Box>
  );
};
